// reducers
import { useSelector, useStore } from 'react-redux';
import { selectCountry } from 'hyc-store/reducers/countries/countriesReducer';
import { selectDistribution, updateDistribution } from 'hyc-store/reducers/distribution';

// components
import {
    Card,
    CardFooter, CardFooterItem
} from "shared/components/bulma/card";
import { ModalShipment } from './modal-shipment';
import { Button } from 'shared/components/bulma/button';

// pipes
import { DisplayDate } from "shared/pipes/display-date";

// functions
import { useToggle } from 'shared/functions';

import * as helper from '../helper';

const ShipmentCard = ({ week, partnerData, partner }) => {
    const store = useStore();
    const country = useSelector(selectCountry);
    const { month, data } = useSelector(selectDistribution);

    const [modal, setModal] = useToggle(false);

    const cardFooterClass = [
        'background-color-',
        week.color,
        ' has-text-centered p-0'
    ].join('');

    const handleEdit = () => {
        setModal(true);
        store.dispatch(updateDistribution({
            month
        }));
    }

    const handleDelete = () => {
        const payload = { week: week.label, ...partnerData, partner }
        helper.deleteShipment(payload, month, country);

        const updatedWeek = { ...data[week.label] };
        const weekData = {
            ...updatedWeek, [partner]: null
        }


        store.dispatch(updateDistribution({
            month, data: { ...data, [week.label]: weekData }
        }));
    }

    if (!partnerData) { return null };
    const { shipment_date, return_date } = partnerData;

    return (
        <div className="column is-3 mt-1">
            <Card>
                <CardFooter className={cardFooterClass}>
                    <CardFooterItem className="subtitle is-5 has-text-white has-text-weight-bold">
                        <div className="columns is-vcentered">
                            <div className="column is-9">
                                {`${week.label} ${partner}`}
                            </div>
                            <div className="column is-3 px-0 py-3">
                                <div className="columns m-0 p-0">
                                    <div className="column py-1 px-0">
                                        <Button className="is-small is-outlined is-grey"
                                            onClick={handleEdit}
                                        >
                                            <span className="icon">
                                                <i className="fas fa-pen"></i>
                                            </span>
                                            {/* <span>Edit</span> */}
                                        </Button>
                                    </div>
                                    <div className="column py-1">
                                        <Button className="is-small is-outlined is-grey"
                                            onClick={handleDelete}
                                        >
                                            <span className="icon">
                                                <i className="fas fa-trash"></i>
                                            </span>
                                            {/* <span>Delete</span> */}
                                        </Button>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </CardFooterItem>
                </CardFooter>

                <CardFooter>
                    <CardFooterItem className="has-text-success my-0">
                        <DisplayDate>
                            {shipment_date}
                        </DisplayDate>
                    </CardFooterItem>

                    <CardFooterItem className="has-text-danger my-0">
                        <DisplayDate>
                            {return_date}
                        </DisplayDate>
                    </CardFooterItem>

                </CardFooter>
            </Card >

            {/* Shipment Modal */}
            <ModalShipment modal={modal} handleModal={setModal} payload={{ ...partnerData, partner, week: week.label }} />
        </div>
    );
}

export { ShipmentCard }
